export class GuardIs {
    public nullOrUndefined(value: any | null | undefined): boolean {
        return this.null(value) || this.undefined(value);
    }

    public null(value: any | null | undefined): boolean {
        return value === null;
    }

    public undefined(value: any | null | undefined): boolean {
        return value === undefined;
    }

    public nullOrWhitespace(value: string | null | undefined): boolean {
        return this.nullOrUndefined(value) || value === undefined || value === null || value.replace(/\s/g, '').length === 0;
    }

    public nullOrEmpty(value: any | null | undefined): boolean {
        return this.nullOrUndefined(value) || Object.keys(value).length === 0;
    }

    public same(valueA: any | null | undefined, valueB: any | null | undefined): boolean {
        return valueA === valueB;
    }

    public type<T>(value: any  | null | undefined): value is T {
        return value as T ? true : false;
    }
}

export class GuardNot {

    constructor(private is: GuardIs) {

        // NOTE: we cant use Guard here as the static type is not jet defined
        if (is === null || is === undefined) {
            throw new Error('invalid constructor argument');
        }
    }

    public nullOrUndefined(value: any | null | undefined): boolean {
        return !this.is.nullOrUndefined(value);
    }

    public null(value: any | null | undefined): boolean {
        return !this.is.null(value);
    }

    public undefined(value: any | null | undefined): boolean {
        return !this.is.undefined(value);
    }

    public nullOrWhitespace(value: string | null | undefined): boolean {
        return !this.is.nullOrWhitespace(value);
    }
    public nullOrEmpty(value: any | null | undefined): boolean {
        return !this.is.nullOrEmpty(value);
    }

    public same(valueA: any | null | undefined, valueB: any | null | undefined): boolean {
        return !this.is.same(valueA, valueB);
    }

    public type<T>(value: any  | null | undefined): value is T {
        return !this.is.type<T>(value);
    }
}

export class GuardAgainst {

    constructor(private is: GuardIs) {

        // NOTE: we cant use Guard here as the static type is not jet defined
        if (is === null || is === undefined) {
            throw new Error('invalid constructor argument');
        }
    }

    public nullOrUndefined(value: any) {
        this.undefined(value);
        this.null(value);
    }

    public null(value: any) {
        if (this.is.null(value)) {
            Guard.throw(`guarded against null`);
        }
    }

    public undefined(value: any) {
        if (this.is.undefined(value)) {
            Guard.throw(`guarded against undefined`);
        }
    }

    public nullOrWhitespace(value: string) {
        if (this.is.nullOrWhitespace(value)) {
            Guard.throw(`guarded against whitespace`);
        }
    }


    public nullOrEmpty(value: any) {
        if (this.is.nullOrEmpty(value)) {
            Guard.throw(`guarded against empty Object`);
        }
    }

    public same(valueA: any, valueB: any) {
        if (this.is.same(valueA, valueB)) {
            Guard.throw(`guarded against empty Object`);
        }
    }

    public type<T>(value: any) {
        if (this.is.type<T>(value)) {
            Guard.throw(`guarded against empty Object`);
        }
    }
}

export class Guard {
    public static readonly against = new GuardAgainst(new GuardIs());
    public static readonly is = new GuardIs();
    public static readonly not = new GuardNot(new GuardIs());

    public static throw(message: string) {
        throw new Error(message ? message : 'Guard check failed');
    }

    public static test() {

        console.log('Guard.null NULL', Guard.is.null(null), Guard.not.null(null));
        console.log('Guard.null \' \'', Guard.is.null(' '), Guard.not.null(' '));
        console.log('Guard.undefined undefined', Guard.is.undefined(undefined), Guard.not.undefined(undefined));
        console.log('Guard.undefined \' \'', Guard.is.undefined(' '), Guard.not.undefined(' '));

        console.log('Guard.nullOrUndefined NULL', Guard.is.nullOrUndefined(null), Guard.not.nullOrUndefined(null));
        console.log('Guard.nullOrUndefined undefined', Guard.is.nullOrUndefined(undefined), Guard.not.nullOrUndefined(undefined));
        console.log('Guard.nullOrUndefined \' \'', Guard.is.nullOrUndefined(' '), Guard.not.nullOrUndefined(' '));

        console.log('Guard.nullOrWhitespace NULL', Guard.is.nullOrWhitespace(null), Guard.not.nullOrWhitespace(null));
        console.log('Guard.nullOrWhitespace \' \'', Guard.is.nullOrWhitespace(' '), Guard.not.nullOrWhitespace(' '));
        console.log('Guard.nullOrWhitespace \'a\'', Guard.is.nullOrWhitespace('a'), Guard.not.nullOrWhitespace('a'));

        console.log('Guard.nullOrEmpty \'abc\'', Guard.is.nullOrEmpty('abc'), Guard.not.nullOrEmpty('abc'));
        console.log('Guard.nullOrEmpty \'\'', Guard.is.nullOrEmpty(''), Guard.not.nullOrEmpty(''));
        console.log('Guard.nullOrEmpty NULL', Guard.is.nullOrEmpty(null), Guard.not.nullOrEmpty(null));
        console.log('Guard.nullOrEmpty []', Guard.is.nullOrEmpty([]), Guard.not.nullOrEmpty([]));
        console.log('Guard.nullOrEmpty [1,2,3]', Guard.is.nullOrEmpty([1, 2, 3]), Guard.not.nullOrEmpty([1, 2, 3]));
    }
}

// Guard.test();
